import { useReduxState } from 'hooks';
import { ErrorPage } from 'components/error';
import { CalendarEventPage } from 'components/calendar';

interface Props {
  children: React.ReactNode;
}

/**
 * Wraps the calendar event feedback pages. Renders a 404 when the feedback
 * feature flag is off so the pages are unreachable even by direct URL.
 */
const CalendarEventFeedbackPage = ({ children }: Props) => {
  const {
    serverConfig: { featureFlags }
  } = useReduxState();

  if (!featureFlags.enableFeedbackForCalendarEvents) {
    return <ErrorPage statusCode={404} />;
  }

  return (
    <CalendarEventPage activeLink="/feedback">{children}</CalendarEventPage>
  );
};

export default CalendarEventFeedbackPage;
